/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import classnames from "classnames";
import { useMediaQuery } from "react-responsive";

/**
 * Internal dependencies
 */
import Sidebar from "./sidebar";
import Content from "./content";
import Topbar from "./topbar";

/**
 * Style dependencies
 */
import "./layout.scss";

const Layout = ({ children, ...props }) => {
  const isMobile = useMediaQuery({ maxWidth: "1150px" });
  const classes = classnames("dashboard__layout", "is-mobile");
  const innerWrapperClasses = classnames("dashboard__inner-content-wrapper");

  const defaultRender = ({
    sidebar,
    content,
    classes,
    innerWrapperClasses,
  }) => {
    return (
      <Box className={classes}>
        <Topbar />
        <Box className={innerWrapperClasses}>
          {sidebar && <Sidebar position="left">{sidebar}</Sidebar>}
          {content && <Content>{content}</Content>}
        </Box>
      </Box>
    );
  };

  let renderProps = { ...props, classes, innerWrapperClasses, isMobile };

  return (children && children(renderProps)) || defaultRender(renderProps);
};

export default Layout;
